import { applicationResource } from './../../customer/applicationManage/request';
import { customerResource } from './../customerManage/request';
import { addGrayscale } from './request';
export default {
  data() {
    return {
      applicationList: [],
      dialogVisible: false,
      dataFrom: {
        name: '',
        mobile: '',
        applicationId2: [],
        applicationId: '',
        customerId: undefined,
        remark: ''
      },
      customerList: []
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('用户名')
        }],
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: this.phoneCheck
        }],
        applicationId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('归属应用')
        }],
        customerId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('归属客户')
        }]
      };
    }
  },
  methods: {
    phoneCheck(rule, value, callbackFn) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callbackFn(this.$t('请输入') + this.$t('手机号码'));
        return;
      }
      callbackFn();
    },
    init() {
      customerResource().then(res => {
        console.log(res);
        this.customerList = res;
      });
      this.dialogVisible = true;
    },
    getDataFun() {
      applicationResource({
        customerId: this.dataFrom.customerId
      }).then(res => {
        console.log(res, 5555);
        this.applicationList = res;
      });
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.dataFrom.applicationId = this.dataFrom.applicationId2.join(',');
          addGrayscale(this.dataFrom).then(() => {
            this.$message.success(this.$t('添加成功'));
            this.$emit('ok');
          });
        }
      });
    }
  }
};